<script setup lang="ts">
import {onMounted, ref, watch} from 'vue';

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  expanded: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['update:expanded', 'expanded']);

const isExpanded = ref(props.expanded);
const textContainer = ref<HTMLElement | null>(null);

const safeText = ref(props.text);

onMounted(() => {
  safeText.value = props.text.replace(
    /<a(?![^>]*target)/g,
    '<a target="_blank" rel="noopener noreferrer"'
  );

  document.addEventListener('click', (event) => {
    if (
      textContainer.value &&
      !textContainer.value.contains(event.target as Node) &&
      !(event.target as HTMLElement).closest('.interactive-element')
    ) {
      isExpanded.value = false;
      scrollToTop();
      emit('expanded', isExpanded.value);
    }
  });
});

const scrollToTop = () => {
  if (textContainer.value) {
    textContainer.value.scrollTop = 0;
  }
};

const toggleText = () => {
  isExpanded.value = !isExpanded.value;
  if (!isExpanded.value) scrollToTop();
  emit('update:expanded', isExpanded.value);
  emit('expanded', isExpanded.value);
};

watch(
  () => props.expanded,
  (newVal) => {
    isExpanded.value = newVal;
    if (!newVal) scrollToTop();
    emit('expanded', isExpanded.value);
  }
);
</script>

<template>
  <div
    @click="toggleText"
    @wheel.stop
    class="relative post-message flex cursor-pointer text-white  mr-3"
  >
    <div
      :class="isExpanded ? 'line-clamp-none' : 'line-clamp-1'"
      class="max-h-[42vh] overflow-y-auto break-words whitespace-pre-line"
      style="scrollbar-width: none; word-break: break-word"
      ref="textContainer"
      v-html="safeText"
    ></div>
  </div>
</template>

<style scoped>
.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-none {
  display: block;
  -webkit-line-clamp: unset;
}
</style>
